// @flow

import * as React from 'react';
import { CallToActionButton } from 'components/Button';
import type { StickyHeaderLinksGradBlockData } from 'api/cms';
import StickyHeaderLinks from './StickyHeaderLinks';

const StickyHeaderLinksGradBlock = ({
  data: { links },
  loggedIn,
  hasGradProgram
}: {
  data: StickyHeaderLinksGradBlockData,
  loggedIn: boolean,
  hasGradProgram: boolean
}) => (
  <StickyHeaderLinks
    links={links}
    button={
      <CallToActionButton loggedIn={loggedIn} hasGradProgram={hasGradProgram} />
    }
  />
);

export default StickyHeaderLinksGradBlock;
